import { render, staticRenderFns } from "./pi-tag.vue?vue&type=template&id=29b2a472&"
import script from "./pi-tag.vue?vue&type=script&lang=js&"
export * from "./pi-tag.vue?vue&type=script&lang=js&"
import style0 from "./pi-tag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports